import styled from 'styled-components';

export const Container = styled.div`
  width: fit-content;

  label {
    display: block;
    margin-bottom: 6px;
    color: #101d40;
    font-weight: 500;
    font-size: 14px;
    font-family: 'Sora', sans-serif;
  }
`;

export const Content = styled.div`
  display: flex;
  height: 38px;
  align-items: center;
  justify-content: space-evenly;
  border: 2px solid #e6effb;
  background-color: #ffffff;
  font-size: 16px;
  font-family: 'Sora', sans-serif;
  transition: all 0.2s ease-in-out;
  color: #101d40;
  border-radius: 5px;

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    background: none;
    border: none;
    font-size: 13px;
    padding: 7.5px 11px;
    color: #329bfc;

    &:disabled {
      color: #a6a6a6;
      cursor: not-allowed;
    }
  }

  span {
    font-size: 13px;
    padding: 0px 3px;
  }

  &:hover {
    border-color: #329bfc;
  }
`;
